import { GeolocatedProfile, Profile } from 'types/profile.types';

// Geolocation is optional on a profile: keep only usable numeric coordinates.
export const hasCoordinates = (profile: Profile): profile is GeolocatedProfile =>
  typeof profile.latitude === 'number' && typeof profile.longitude === 'number';
